// src/components/OccupationSelect.js

import React from "react";

var occupations = [
    { code: "1", text: "Politicians" },
    { code: "2", text: "Civil Servants" },
    { code: "3", text: "Gas Station Owners" },
    { code: "4", text: "Retail Business Owners" },
    { code: "5", text: "Car Dealerships" },
    { code: "6", text: "Travel Agencies" },
    { code: "7", text: "Investment Brokers" },
    { code: "8", text: "Jewelry Dealers" },
    { code: "9", text: "Lawyers" },
    { code: "10", text: "Accountants" },
    { code: "11", text: "Other" },
    { code: "12", text: "Financial Services" },
    { code: "13", text: "Hospitality" },
    { code: "14", text: "Banker" },
    { code: "15", text: "IT Financial Services" },
    { code: "16", text: "Entrepreneur" },
    { code: "17", text: "Plumber" },
    { code: "18", text: "Graphic Designer" },
    { code: "19", text: "Photographer" },
    { code: "20", text: "Journalist" },
    { code: "21", text: "Brand Manager" },
    { code: "22", text: "Event Planner" },
    { code: "23", text: "Auto Mechanic" },
    { code: "24", text: "Landscaper" },
    { code: "25", text: "Groundskeeper" },
    { code: "26", text: "Fisherman" }
];
occupations = occupations.sort((a, b) => a.text.localeCompare(b.text));
const OccupationSelectOB = ({ selectedValue, onChange }) => {
    return (
        <select
          className="form-control no-icon"
          value={selectedValue}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">Select Occupation</option>
          {occupations.map((occ) => (
            <option key={occ.code} value={occ.code}>
              {occ.text}
            </option>
          ))}
        </select>
      );
};

export default OccupationSelectOB;
